module.exports = __webpack_public_path__ + "static/media/giftsReceived_10_25.06042580.png";